export const DEFAULT_DATE_PICKER_MIN_DATE = new Date(2009, 0, 1);
export const DEFAULT_DATE_PICKER_MAX_DATE = new Date(2039, 11, 31);
